import { AuthLoginActionTypes } from './authTypes';

export const authLoginApiResponseSuccess = (actionType: string, data: any) => ({
  type: AuthLoginActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const authLoginApiResponseError = (actionType: string, error: string) => ({
  type: AuthLoginActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const sessionCheckAction = () => ({
  type: AuthLoginActionTypes.SESSION_CHECK,
  payload: {},
});

export const logoutUser = () => ({
  type: AuthLoginActionTypes.LOGOUT_USER,
});
